<template>
    <div>
        <CCTableAddItems
            :items.sync="tables.fieldMapping.items"
            :fields="traslateLabels(tables.fieldMapping.fields)"
            v-bind="tables.fieldMapping"
        >
            <template #key="{ index }">
                <SelectFields
                    :value.sync="tables.fieldMapping.items[index].key"
                    :placeholder="$t('Select a field')"
                    size="sm"
                    class="mb-0"
                    :advanceMode="true"
                    uses="DELIVERY"
                    optionsValue="name"
                />
            </template>
            <template #name="{ index }">
                <CInput
                    :value.sync="tables.fieldMapping.items[index].name"
                    :placeholder="$t('enter_the_value')"
                    :invalidFeedback="$t('value_is_required')"
                    class="mb-0"
                    size="sm"
                />
            </template>
        </CCTableAddItems>
    </div>
</template>

<script>
/**Components */
import ButtonAdd from "~/components/ButtonAdd.vue";
import ButtonTrash from "~/components/ButtonTrash.vue";
import SelectFields from "£lement/SelectFields";
import CCTableAddItems from "~/components/CCTableAddItems";

/** Mixins */
import tableMixin from "~/mixins/table.js";
import traslateMixin from "~/mixins/traslate.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import FilterTypeOptions from "~/pages/app/config/options/filter_type";
import MappingFormatType from "~/assets/options/mapping_format_type.json";
import DateFormat from "~/assets/options/date_format.json";

export default {
    name: "CCTableMappingFields",
    mixins: [traslateMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    options: {
        FilterTypeOptions,
        MappingFormatType,
        DateFormat,
    },
    components: {
        SelectFields,
        CCTableAddItems,
        ButtonAdd,
        ButtonTrash,
    },
    data() {
        return {
            tables: {
                fieldMapping: {
                    items: [],
                    fields: [
                        {
                            key: "key",
                            label: "Key",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        },
                        {
                            key: "name",
                            label: "Name",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        },
                        {
                            key: "_options",
                            label: "Options",
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                        }
                    ],
                    loading: false,
                },
            },
            defaultMappingFieldItem: {
                key: null,
                name: null,
                format: {
                    active: false,
                    type: null,
                    mask: null,
                    formatDate: null
                }
            },
            modals: {},
            modelFields: [],
        };
    },
    props: {
        value: {
            type: Array | Object,
            default: () => {
                return [];
            },
        },
    },
    watch: {
        "tables.fieldMapping.items": {
            handler(newValue) {
                this.$emit("update:value", newValue);
                this.$emit("change", newValue);
            },
            deep: true,
        },
        value(newValue) {
            if (Array.isArray(newValue)) {
                this.tables.fieldMapping.items = newValue;
            }
        },
    },
    methods: {
        addToggleAttrToItems(items) {
            return items.map(function (item) {
                if (!item._toggled) {
                    item = {
                        ...item,
                        _toggled: false,
                    };
                }
                return item;
            });
        },
    },
    mounted() {
        if (Array.isArray(this.value)) {
            this.tables.fieldMapping.items = this.addToggleAttrToItems(
                this.value
            );
        }
    },
};
</script>

<style>
</style>